import { defineComponent, ref } from 'vue'
import './index.sass'

export default defineComponent({
  props: {
    manager: {
      type: String,
      default: () => ""
    },
    logist: {
      type: String,
      default: () => ""
    }
  },
  setup (props) {

    const manager = ref(props.manager ? JSON.parse(props.manager as string) : "")
    const logist = ref(props.logist ? JSON.parse(props.logist as string) : "")

    return () => {
      return (
        <div class="manager-logist">
          <div class="manager-contacts-title">Вопросы по заявке вы можете задать</div>
          <div class="manager-contacts-person">
            {manager.value
              ? (
                <div class="manager-contacts-person-content">
                  <div class="manager-contacts-person-name">{manager.value.name}</div>
                  <div class="manager-contacts-person-position">Менеджер по продажам</div>
                  <a href={`mailto:${manager.value.email}`} class="manager-contacts-person-email">{manager.value.email}</a>
                  <a href={`tel:+74956460858,${manager.value.phone}`} class="manager-contacts-person-phone">+7 (495) 646-08-58, доб. {manager.value.phone}</a>
                </div>
              ) : null
            }
          </div>

          {logist.value
            ? (
              <div class="manager-contacts-person">
                <div class="manager-contacts-person-content">
                  <div class="manager-contacts-person-name">{logist.value.name}</div>
                  <div class="manager-contacts-person-position">Логист</div>
                  <a href={`mailto:${logist.value.email}`}  class="manager-contacts-person-email">{logist.value.email}</a>
                  <a href={`tel:+74956460858,${logist.value.phone}`} class="manager-contacts-person-phone">+7 (495) 646-08-58, доб. {logist.value.phone}</a>
                </div>
              </div>
            ) : null
          }
        </div>
      )
    }
  }
})